/**
 * Get Tariff Levels Use Case
 * Fetches tariff period names for dynamic column headers
 */

import { SessionsReportRepository } from '../data/sessions-report-repository';
import { TariffLevelsMappingResponse } from '../types/api-types';

export class GetTariffLevelsUseCase {
  constructor(private readonly repository: SessionsReportRepository) {}

  /**
   * Execute use case to get tariff levels mapping
   * Returns tariff names for dynamic column headers (e.g., "שפל", "Const", "פסגה")
   */
  async execute(): Promise<TariffLevelsMappingResponse> {
    return this.repository.getTariffLevels();
  }
}
